'use client';

import { openCalendlyPopup } from '../../openCalendlyPopup';

export function BookCallButton(props: { buttonLabel: string }) {
  return (
    <button
      data-testid="book-a-call-button"
      data-button-on-click="open-booking-modal"
      onClick={openCalendlyPopup()}
      className="flex items-center gap-2 rounded-full border border-primary px-8 py-4 font-medium text-primary transition-all hover:-translate-y-1 hover:bg-primary/5"
    >
      {props.buttonLabel}
    </button>
  );
}
